import COUNTRIES from '../countries.translations'

import translations from './lead.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/lead'

export const lead: Metal = {
  id: 6,
  slug: 'lead',
  name: t.name,
  symbol: 'Pb',
  // Coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Rajsamand, lead mine (India)',
      region: t.mine0Region,
      slug: 'rajsamand',
      coordinates: [73.88, 25.07],
    },
    {
      name: 'Mount Isa, lead mines (Australia)',
      region: t.mine1Region,
      slug: 'mount-isa',
      coordinates: [139.49, -20.73],
    },
    {
      name: 'Uchaly, lead mine (Russia)',
      region: t.mine2Region,
      slug: 'uchaly',
      coordinates: [59.46, 54.36],
    },
    {
      name: 'Noatak, lead mine (United States)',
      region: t.mine3Region,
      slug: 'noatak',
      coordinates: [-162.97, 67.57],
    },
    {
      name: 'San Marcos, lead mine (Peru)',
      region: t.mine4Region,
      slug: 'san-marcos',
      coordinates: [-77.15, -9.52],
    },
  ],
  countries: [
    { name: COUNTRIES.china, percent: 44.2 },
    { name: COUNTRIES.australia, percent: 10 },
    { name: COUNTRIES.peru, percent: 6.3 },
    { name: COUNTRIES.india, percent: 5.1 },
    { name: COUNTRIES.russia, percent: 5.1 },
  ],
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 1, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 4, ...t.supplyRisk },
    recycling: { score: 5, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
          credit: 'CFOTO / Getty',
        },
      ],
    },
  },
  // Galena is mined alongside all three.
  related: ['zinc', 'silver', 'copper'],
}
